import { render } from "./right-bar.vue?vue&type=template&id=f311fd08"
import script from "./right-bar.vue?vue&type=script&lang=js"
export * from "./right-bar.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__